import React from "react";
import styled from "styled-components";
import renderIf from "render-if";
import ThemeLogo from "../components/ThemeLogo";
import Typography from "@material-ui/core/Typography";

const Logo = styled(ThemeLogo)`
  width: 10%;
  margin-right: 10px;
  vertical-align: middle;
`;

const Wrapper = styled.header`
  margin: 0 auto;
  max-width: 750px;
  padding: 20px;
  box-sizing: border-box;
`;

const TradeInText = styled(Typography).attrs({ display: "inline" })``;

const TradeInHeader = ({ removeBranding }) => {
  return (
    <Wrapper>
      {renderIf(!removeBranding)(<Logo />)}
      <TradeInText>Trade In Report</TradeInText>
    </Wrapper>
  );
};

export default TradeInHeader;
